<div class="delivery-address-block">
  <div class="checkout-section-title">
    <h2 class="delivery-address-block-label text-b3-m-700 text-md-b1-s-700 text-lg-b1-m-700 color-black">
      адрес доставки
    </h2>

    <sd-checkout-validation-error
      [errorKeys]="['DELIVERY_ADDRESS_REQUIRED', 'DELIVERY_CITY_MISMATCH_WITH_CURRENT_CITY']"
    ></sd-checkout-validation-error>
  </div>

  <div class="delivery-address-block-state">
    @switch (state()) {
      @case (deliveryState.Loading) {
        <div class="sd-group-skeleton-gradient-wave">
          <div class="sd-skeleton"></div>
        </div>
      }
      @case (deliveryState.AddAddress) {
        <sd-delivery-add-address />
      }
      @case (deliveryState.ShowAddress) {
        <sd-delivery-active-address />
      }
    }
  </div>
</div>
